export default "__VITE_ASSET__CsUCU_SR__"